export interface MapRegion {
  name: string;
  center: {
    lat: number;
    lng: number;
  };
  zoom: number;
  bounds?: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
}

export interface MapConfig {
  apiKey: string;
  defaultRegion: MapRegion;
  availableRegions: MapRegion[];
}

// Regiões pré-configuradas
export const REGIONS: Record<string, MapRegion> = {
  RIO_GRANDE_DO_SUL: {
    name: 'Rio Grande do Sul',
    center: { lat: -30.2, lng: -53.5 }, // Centro geográfico do RS
    zoom: 6,
    bounds: {
      north: -27.0,
      south: -33.8,
      east: -49.5,
      west: -58.0
    }
  },
  BRASIL: {
    name: 'Brasil',
    center: { lat: -14.2350, lng: -51.9253 },
    zoom: 5
  },
  PORTO_ALEGRE: {
    name: 'Porto Alegre',
    center: { lat: -30.0346, lng: -51.2177 },
    zoom: 11
  }
};

// Election result data
export interface ElectionResult {
  ano: number;
  votos_obtidos: number;
  meta_votos: number | null;
  observacao?: string | null;
  percentage?: number | null;
  status?: 'success' | 'warning' | 'danger' | 'neutral';
}

// City responsible person
export interface CityResponsible {
  id: number;
  nome: string;
  email?: string;
  foto_url?: string | null;
}

// Extended city data with election history
export interface CityData {
  id: number;
  nome: string;
  uf: string;
  populacao?: number;
  populacao_votantes?: number;
  populacao_ano?: number | null;
  responsavel?: CityResponsible | null;
  num_demandas?: number;
  num_multiplicadores?: number;
  multiplicadores?: Array<{ id: number; nome: string }>;
  projecao_votos?: number;
  mesorregiao?: string;
  electionHistory?: ElectionResult[];
}

// User for assignment
export interface Usuario {
  id: number;
  nome: string;
  email: string;
  nivel_acesso: 'SUPER_ADMIN' | 'ADMIN' | 'ASSESSOR' | 'VISUALIZADOR';
  foto_url?: string | null;
}
